import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function KidsKarateWhatYouLearn() {
  return <section className="py-24 bg-off-white" data-id="element-2085">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2086">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-2087">
          <div data-id="element-2088">
            <h2 className="text-4xl md:text-5xl text-ink mb-8" data-id="element-2089">
              What You'll Learn
            </h2>
            <ul className="flex flex-col gap-4" data-id="element-2090">
              {['Respect for parents, teachers, and peers', 'Goal setting through the belt progression system', 'Physical fitness, balance, and coordination', 'Self-defense fundamentals and stranger awareness', 'How to handle failure and bounce back stronger', 'Dynamic Taekwondo kicking techniques'].map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-warm" data-id="element-2091">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-2092" />
                  <span data-id="element-2093">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10" data-id="element-2094">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-2095">
                Start With a Trial Class
              </Link>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]" data-id="element-2096">
            <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-2097" />
          </div>
        </div>
      </div>
    </section>;
}